<template>
  <div class="home-box">
    <div class="box">
      <div class="box-title">
        <div :class="active==index?'title-active':''"  @click="activeIndex(item,index)" v-for="(item,index) in typeList">{{item.name}}</div>
      </div>
      <div class="scroll">
        <div class="title">
          <div v-if="search.storeType==3" class="t-l"><el-input v-model="search.name" clearable @change="getData" size="small" placeholder="请输入内容"></el-input><div style="margin-left:10px" class="btn1" @click="getData">搜索</div></div>
          <div v-else></div>
          <div @click="addItem" v-if="search.storeType==2" class="btn11" >新增题目</div>
          <div  v-if="search.storeType==3" class="btn1" @click="addFun">新增</div>
        </div>
        <div class="s-l" v-if="search.storeType==2">
          <div class="s-l-i" v-for="item in listData">
            <div class="a-title">
              <span style="margin-left:12px" v-if="item.questType==1">单选题</span>
              <span style="margin-left:12px" v-if="item.questType==2">多选题</span>
              <span style="margin-left:12px" v-if="item.questType==3">判断题</span>
              <div class="a-t-r">
                <div class="btn2" @click="handleEdit1(item)">编辑</div>
                <div class="btn3" @click="delExam(item)">删除</div>
              </div>
            </div>
            <div class="a-row">
              
              <div class="a-row-r">{{item.index}}、{{item.questWord}}</div>
            </div>
            <div class="a-row1">
              <span class="a-row-item" v-for="child in item.optionList" :key="child.id">{{child.opOption}}、{{child.opWord}}</span>
            </div>
            <div class="a-row1"><span class="a-row-item">正确答案：{{item.answer}}</span></div>
          </div>
        </div>
        <div class="s-l1" v-if="search.storeType==3">
          <el-table
            :header-cell-style="{background:'#EEEEEE',color:'#999999;',fontFamily: 'SourceHanSansCN-Regular',fontSize:'14px',fontWeight: 'normal'}"
            :data="listData"
            :border="true"
            height="70.4vh"
            style="width: 100%">
            <el-table-column
              prop="index"
              label="序号"
              >
            </el-table-column>
            <el-table-column
              prop="name"
              label="题库名城"
              >
            </el-table-column>
            <el-table-column
              prop="questionNum"
              label="题目数量">
            </el-table-column>
            <el-table-column
              prop="createDate"
              label="创建时间">
            </el-table-column>
            <el-table-column
              prop="address"
              label="操作"
              width="200">
              <template slot-scope="scope">
                <div style="display:flex">
                  <div @click="entertestList(scope.row.id)" style="margin-left:8px" class="btn2">查看</div>
                  <div @click="handleEdit(scope.$index, scope.row)" style="margin-left:8px" class="btn2">编辑</div>
                  <div @click="handleDel(scope.$index, scope.row)" class="btn3">删除</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="search.pageNum"
          :page-sizes="[10,20,50,100, 200, 300, 400]"
          :page-size="search.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
    <el-dialog
              :title="dialogTitle"
              :visible.sync="addFormVisible"
              center
              width="500px"
              :append-to-body="true"
              :lock-scroll="false"
              class="add-form"
            >
              <el-form :model="addForm" label-width="120px" ref="ruleForm">
                <el-form-item label="题库名称" required>
                  <el-input v-model="addForm.name" autocomplete="off"></el-input>
                </el-form-item>
                <!-- <el-form-item label="排序">
                  <el-input v-model="addForm.sort" autocomplete="off"></el-input>
                </el-form-item> -->
                <el-form-item label="备注">
                  <el-input type="textarea" v-model="addForm.remarks"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="addFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="sumbitAddRow('ruleForm')">确 定</el-button>
              </div>
            </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
  export default {
    data() {
      return {
        typeList: [
          {
            name:'每日答题',
            value:'0',
            type:2
          },
          {
            name:'专项答题',
            value:'1',
            type:3
          },
        ],
        active:0,
        search:{
          name:'',
          // groupId:util.session.get('groupId'),
          groupType:'1',
          pageSize:10,
          pageNum:1,
          module:'party',
          storeType:2
        },
        dataList:[],
        total:0,
        aa:base.httpCtx,
        listData:[],
        addFormVisible:false,
            addForm:{
                id:'',
                name:'',
                remarks:'',
            },
        dialogTitle:''
      }
    },
    mounted(){
      if(this.$route.query.pageNum){
        this.search.pageNum=this.$route.query.pageNum*1
      }
      if(this.$route.query.pageSize){
        this.search.pageSize=this.$route.query.pageSize*1
      }
      if(this.$route.query.storeType){
        this.search.storeType=this.$route.query.storeType
      }
      if(this.$route.query.active){
        this.active=this.$route.query.active*1
      }
      if(this.active==0){
        this.getData1()
      }else{
        this.getData()
      }
    },
    methods:{
      delExam(row){
      var that = this;
      this.$confirm('此操作将永久删除该题目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.appExamDel({
          id:row.id,
          storeId:row.storeId
        }).then(function(resp){
          if(resp.data.code=="200"){
              that.$message.success('题目删除成功');
              that.getData1();
          }else{
              that.$message.error(resp.data.msg);
          }
        });
      }).catch(err => {})
    },
        //修改
    handleEdit1(row){
      this.$router.push({path: "/topicOperation", query: {
        id: row.id,
        module:this.search.module,
        storeType:this.search.storeType
      }})
    },
      addItem(){
        let that = this
        this.$router.push({
          path:'/topicOperation',
          query:{
            id:0,
            module:this.search.module,
            storeType:this.search.storeType
          }
        })
      },
      getData1() {
        var that = this;
        myHttp.getExamList({
          pageNum:this.search.pageNum,
          pageSize:this.search.pageSize,
          storeId:'',
          // groupId:util.session.get('groupId'),
          groupType:1
        }).then(function(resp){
          // console.log(resp)
          if(resp.data.code=="200"){
            var list = resp.data.data.pageInfo.list||[];
            for(var i=0;i<list.length;i++){
              list[i].index = ((that.search.pageNum - 1) * that.search.pageSize)+(i+1);
            }
            that.listData = list;
            // console.log( that.listData)
            that.total = resp.data.data.pageInfo.total||0
          }
        });
        // myHttp.getEntPerson(this.search).then(function(resp){
        //   if(resp.data.code=="200"){
        //       var list = resp.data.data.pageInfo||[];
        //       that.listData = list;
        //   }else{
        //     that.$message.error(resp.data.msg);
        //   }
        // },function(){});
      },
          //删除
        handleDel(index,row){
        var that = this;
        this.$confirm('此操作将永久删除该题库, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            myHttp.delStore({
            id:row.id
            }).then(function(resp){
            if(resp.data.code=="200"){
                that.$message.success('题库删除成功');
                that.getData();
            }else{
                that.$message.error(resp.data.msg);
            }
            });
        }).catch(err => {})
        },
          //修改
        handleEdit(index,row){
        this.dialogTitle = "修改题库";
        this.addFormVisible = true;
        this.addForm.id = row.id;
        this.addForm.name = row.name;
        this.addForm.sort = row.sort;
        this.addForm.remarks = row.remarks;
        },
      // 查看题目
        entertestList(id){
            this.$router.push({
                path:'/testQuestions',
                query:{
                    id:id,
                    module:this.search.module,
                    storeType:this.search.storeType,
                    pageSize:this.search.pageSize,
                    pageNum:this.search.pageNum
                }
            })
        },
        entertestList1(){
            this.$router.push({
                path:'/testQuestions',
                query:{
                    id:'',
                    module:this.search.module,
                    storeType:this.search.storeType,
                    pageSize:this.search.pageSize,
                    pageNum:this.search.pageNum
                }
            })
        },
          //保存
        sumbitAddRow(formName){
        var that = this;
        // this.addForm.groupId = this.search.groupId;
        this.addForm.groupType = this.search.groupType;
        this.addForm.module = this.search.module;
        this.addForm.storeType = this.search.storeType;
        this.$refs[formName].validate((valid) => {
            if (valid) {
                if(that.addForm.id==""){
                myHttp.createStore(that.addForm).then(function(resp){
                    if(resp.data.code=="200"){
                        that.addFormVisible = false;
                        that.$message.success('题库创建成功');
                        that.getData();
                    }else{
                        that.$message.error(resp.data.msg);
                    }
                });
                }else{
                myHttp.updateStore(that.addForm).then(function(resp){
                    if(resp.data.code=="200"){
                        that.addFormVisible = false;
                        that.$message.success('题库修改成功');
                        that.getData();
                    }else{
                        that.$message.error(resp.data.msg);
                    }
                });
                }
            }
        });
        },
      addFun(){
            this.dialogTitle = '添加题库';
            this.addForm={
                id:'',
                name:'',
                remarks:'',
            },
            this.addFormVisible = true;
        },
      handleSizeChange(val){
        this.search.pageSize = val
        this.search.pageNum = 1
        if(this.active==0){
        this.getData1()
        }else{
          this.getData()
        }
      },
      handleCurrentChange(val){
        this.search.pageNum = val
        if(this.active==0){
          this.getData1()
        }else{
          this.getData()
        }
      },
      getData(){
            var that = this;
            myHttp.getStoreList(this.search).then(function(resp){
                if(resp.data.code=="200"){
                    var list = resp.data.data.pageInfo.list||[];
                    // console.log(resp)
                    that.total = resp.data.data.pageInfo.total||0;
                    list.forEach((item,index)=>{
                      item.index = (that.search.pageNum-1)*that.search.pageSize+index+1
                    })
                    that.listData = list;
                    if(that.listData.length==0){
                        that.dataText = "暂无数据"
                    }
                }else{
                that.$message.error(resp.data.msg);
                that.dataText = "暂无数据"
                }
            },function(){});
        },
      activeIndex(item,index){
        this.search.pageNum=1
        // this.search.newsType = item.value
        // console.log(item,index)
        this.active=index
        this.search.storeType = item.type
        if(this.active==0){
        this.getData1()
      }else{
        this.getData()
      }
      },
      enter(){
        this.$router.push({
          path:'/partyBuildingActivitiesAdd',
          query:{
            type:1
          }
        })
      },
      enter1(item){
        this.$router.push({
          path:'/partyBuildingActivitiesItem',
          query:{
            id:item.id
          }
        })
      }
    }
  }
</script>

<style scoped>
  .home-box{
    width: 100%;
    height: 100%;
    background-color: rgb(245,245,245);
    padding: 10px 24px 10px 16px;
  }
  .box{
    width: 100%;
    height: 100%;
    border-radius: 0px 0px 6px 6px;
    overflow: hidden;
  }
  .box-title{
    height: 5.5vh;
    border-radius: 6px;
    background: #FFFFFF;
    box-shadow: 2px 2px 6px 0px rgba(77, 110, 177, 0.2);
    padding-left:16px;
    display: flex;
  }
  .box-title>div{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #666666;
    margin-right: 22px;
    cursor: pointer;
  }
  .box-title>div:hover{
    opacity: 0.7;
  }
  .title-active{
    border-bottom: 2px solid #4D6EB1;
  }
  .box-title1{
    margin-top:1.1vh;
    height: 5.5vh;
    border-radius: 6px;
    background: #FFFFFF;
    box-shadow: 2px 2px 6px 0px rgba(77, 110, 177, 0.2);
    padding: 10px 16px;
    display: flex;
    justify-content: space-between;
  }
  .t1-l{
    height: 100%;
    display: flex;
  }
  .btn{
    width: 52px;
    height: 100%;
    border-radius: 4px;
    background: #3871E5;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #FFFFFF;
  }
  .btn:hover{
    opacity: 0.7;
    cursor: pointer;
  }
  .scroll{
    height: 83vh;
    overflow: hidden;
    margin-top: 10px;
    border-radius: 6px;
background: #FFFFFF;
box-shadow: 2px 2px 6px 0px rgba(77, 110, 177, 0.2);
  }
  .s-l{
    height: 70.5vh;
    margin-top: 10px;
    overflow: auto;
  }
  .s-l1{
    height: 70.5vh;
    margin-top: 18px;
    padding: 0 8px;
  }
  .s-l-i{
    margin-bottom: 16px;
    padding-left: 16px;
    background: #FAFAFA;
box-sizing: border-box;
border: 1px solid #E1E1E1;
padding-bottom:16px;
margin-left: 6px;
margin-right: 6px;
  }
  .a-title{
    display: flex;
    justify-content: space-between;
    text-align: start;
    margin-top: 16px;
  }
  .a-title>span{
    font-family: PingFangSC-Regular;
font-size: 16px;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
position: relative;
  }
  .a-title>span::before{
    content: " ";
    position: absolute;
    left: -12px;top: 0;
    width: 4px;
    height: 88%;
    background: #4D6EB1;
  }
  .a-t-r{
    display: flex;
  }
  .btn3{
    margin: 0 16px 0 8px;
  }
  .a-row{
     margin-top: 13px;
    display: flex;
    justify-content: start;
    align-items: center;
  }
  .a-row-l{
    width: 20px;
height: 20px;
background: #FA001F;
font-family: SourceHanSansCN-Medium;
font-size: 16px;
font-weight: 500;
letter-spacing: 0em;
color: #FFFFFF;
  }
  .a-row-r{
    margin-left: 13px;
    font-family: PingFangSC-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #525252;
  }
  .a-row1{
    margin-top: 16px;
    display: flex;
    justify-content: start;
    align-items: center;
    padding-left:44px ;
  }
  .a-row-item{
    font-family: PingFangSC-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #525252;
margin-right: 15px;
  }
  .title{
    height: 4.9vh;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ECF0F5;
    padding: 0 8px;
  }
  .t-l{
    display: flex;
  }

  .btn1{
    width: 52px;
height: 32px;
border-radius: 4px;
background: #3871E5;
font-family: PingFangSC-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #FFFFFF;
display: flex;
justify-content: center;
align-items: center;
  }
  .btn11{
    width: 90px;
height: 32px;
border-radius: 4px;
background: #3871E5;
font-family: PingFangSC-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #FFFFFF;
display: flex;
justify-content: center;
align-items: center;
  }
  .btn11:hover,.btn1:hover,.btn2:hover,.btn3:hover{
    cursor: pointer;
    opacity: 0.7;
  }
  ::v-deep .el-pagination{
    box-shadow: 6px 0px 10px 0px rgba(197, 197, 197, 0.3);
  }
  .btn2{
    width: 46px;
height: 26px;
border-radius: 4px;
box-sizing: border-box;
border: 1px solid #D4D6D9;
font-family: PingFangSC-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #31373D;
display: flex;
justify-content: center;
align-items: center;
  }
  .btn3{
   width: 46px;
height: 26px;
border-radius: 4px;
box-sizing: border-box;
border: 1px solid #FFA6A6;
font-family: PingFangSC-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #FFA6A6;
display: flex;
justify-content: center;
align-items: center;
  }
  ::v-deep .cell>span{
  font-size: 14px !important;
  text-align: start !important;
  }
  ::v-deep .cell{
  font-size: 14px !important;
  text-align: start !important;
  }
</style>